import React from 'react';
import { Drawer } from 'rsuite';
import { Checkbox, FormControlLabel, List, ListItem, ListItemText } from '@mui/material';
import { SearchIcon } from '../../assets/images';

const DynamicWidgetList = ({
    open,
    setOpen,
    searchText,
    setSearchText,
    filteredData,
    items,
    handleSelectAllWidgets,
    handleAddWidget,
    handleRemoveWidget,
    layout,
    counter,
    getWidthByWidgetType,
    getHeightByWidgetType,
    setItems,
    setLayout,
    setCounter,
    saveToStorage,
    widgetList
}) => (
    <Drawer open={open} onClose={() => setOpen(false)} size='xs' className='NotificationDrawer'>
        <Drawer.Header>
            <Drawer.Title>
                <div className='WidgetList_Header'>
                    <p>Dashboard Configurations Widgets</p>
                </div>
            </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
            <div className='NotificationListHgtDiv'>
                <div className="m-2 HeaderSiteList">
                    <input
                        id="Search_txt_site"
                        className="SearchViewInput1"
                        type="text"
                        placeholder="Search here"
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        style={{fontSize:"14px"}}
                    />
                    <div className="SearchTextDivConfigTool">
                        <img
                            className="EyeIcon"
                            src={SearchIcon}
                            alt="search icon"
                        />
                    </div>
                </div>
                <div className='WidgetListDiv'>
                    <List
                        sx={{
                            width: '100%',
                            maxWidth: '100%',
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 730,
                            '& ul': { padding: 0 },
                        }}
                    >
                        {/* Select All Checkbox */}
                        <ListItem dense disablePadding>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        edge="start"
                                        className='WidgetListCheckbox'
                                        checked={
                                            filteredData.length > 0 &&
                                            filteredData.every(fd => items.some(item => item.i === String(fd.WidgetID)))
                                        }
                                        // indeterminate={
                                        //     filteredData.some(fd => items.some(item => item.i === String(fd.WidgetID))) &&
                                        //     !filteredData.every(fd => items.some(item => item.i === String(fd.WidgetID)))
                                        // }
                                        onChange={(e) => handleSelectAllWidgets({
                                            checked: e.target.checked,
                                            data: filteredData,
                                            items,
                                            layout,
                                            counter,
                                            getWidthByWidgetType,
                                            getHeightByWidgetType,
                                            setItems,
                                            setLayout,
                                            setCounter,
                                            saveToStorage
                                        })}
                                    />
                                }
                                label="Select All"
                                sx={{ width: '100%', marginLeft: 1 }}
                            />
                        </ListItem>
                        {/* Individual Widget Checkboxes */}
                        {
                            filteredData.length === 0 ? (
                                <ListItem>
                                    <ListItemText primary="No record found" sx={{ textAlign: 'center', width: '100%' }} />
                                </ListItem>
                            ) : (
                                filteredData.map((widget) => {
                                    const { WidgetID, WidgetName, WidgetType } = widget;
                                    const checked = items.some((item) => item.i === String(WidgetID))
                                    return (
                                        <ListItem key={WidgetID} dense disablePadding>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        edge="start"
                                                        className='WidgetListCheckbox'
                                                        checked={checked}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                handleAddWidget(WidgetID);
                                                            } else {
                                                                const itemToRemove = items.find((item) => item.i === String(WidgetID));
                                                                if (itemToRemove) {
                                                                    handleRemoveWidget(itemToRemove.i);
                                                                }
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <span>
                                                        {WidgetName}
                                                        <span style={{ opacity: 0.5, marginLeft: 8, fontSize: '0.9em' }}>
                                                            {WidgetType}
                                                        </span>
                                                    </span>
                                                }
                                                sx={{ width: '100%', marginLeft: 1 }}
                                            />
                                        </ListItem>
                                    );
                                })
                            )
                        }
                    </List>
                </div>
            </div>
        </Drawer.Body>
    </Drawer>
);

export default DynamicWidgetList;